<template>
  <!--  第三方账号-->
  <div class="third-account view-box">
    <navBan title="第三方账号"></navBan>

    <ul class="cell-box">
      <li class="cell-item" v-for="(item, index) of thirdAccountList.list" :key="index" @click="openModal(item)" v-show="!(item.title === '华为' && item.status === false)">
        <div class="cell-title">
          <img class="icon" :src="item.icon" alt="">
          <span class="title-text">{{ item.title }}</span>
        </div>
        <div class="cell-value">
          <span class="value-text">{{item.valuePrefix}}</span>
          <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
        </div>
      </li>
    </ul>
    <!-- <safeVerify ref="safeCheck" pageType="h5" @handleOperate="handleOperate"/> -->
    <!--统一安全验证的弹窗-->
    <safeVerify
      ref="safeCheck"
       pageType="h5"
      :checkVisible="checkVisible"
      @updateCheckVisible="updateCheckVisible"
      @handleOperate="handleOperate"
    />

    <!-- 解除绑定的弹窗-->
    <div v-if="visible" class="modal-mask">
      <div class="modal-body">
        <h3 class="title">解除绑定</h3>
        <div class="icon-contai">
          <div class="icon-box">
            <img class="icon" :src="(currentUnbindItem && currentUnbindItem.icon) || require('../../assets/images/web/wechatActive.svg')" alt="">
          </div>
        </div>
        <h3 class="app-name">{{ (currentUnbindItem && currentUnbindItem.title) || '微信' }}</h3>
        <p class="tip">解除{{ (currentUnbindItem && currentUnbindItem.title) || '微信' }}绑定后将无法继续使用{{ (currentUnbindItem && currentUnbindItem.title) || '微信' }}快速登录</p>
        <div class="btn-box">
          <button @click="unbind" class="button button-plain button-danger">解除绑定</button>
          <button @click="visible = false" class="button button-plain">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import navBan from '@/components/navBan';
import { onBeforeMount, ref } from 'vue';
import { getBingInfo, thirdAccountList, visible, unbind, safeCheck, openModal, currentUnbindItem } from '@/utils/setup/thirdAccount';
import safeVerify from '@/components/safeVerify';

function handleOperate (item) {
  console.log('mobile 第三方', item);
  item.status === true && (visible.value = true);
}

const checkVisible = ref(false);
function updateCheckVisible (val) {
  checkVisible.value = val;
}

onBeforeMount(() => {
  getBingInfo();
});
</script>

<script>
export default {
  name: 'thirdAccount'
};
</script>
<style scoped>
  .view-box{
    padding:16px 32px;
  }
  .cell-box{
    padding:0;
  }
</style>
